import styled from "styled-components";
import { TextField as MuiTextField } from "@mui/material";

export const Container = styled.div`
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  margin-top: 16px;
  margin-bottom: 16px;
  padding: 0 16px;
  height: 500px;
`;

export const Text = styled.div`
  font-size: 16px;
  color: #2b2828;
  padding: 0 8px;
  margin-bottom: 8px;
`;
